import React, { Component } from 'react';
import { connect } from 'react-redux';
import ScheduledBookingsView from './scheduled-bookings-view';
import { getScheduledBookings } from './scheduled-bookings-actions';
import { getLiveBookings } from '../live-bookings/live-bookings-actions';

class ScheduledBookings extends Component {

  componentDidMount() {
    this.props.getScheduledBookings();
    this.props.getLiveBookings();
  }

  render() {
    return <ScheduledBookingsView {...this.props} />
  }

}

const mapStateToProps = (state) => ({
  liveBookings: state.liveBookings,
  scheduledBookings: state.scheduledBookings
});

const mapDispatchToProps = {
  getScheduledBookings: getScheduledBookings,
  getLiveBookings: getLiveBookings
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledBookings);



// WEBPACK FOOTER //
// ./src/components/scheduled-bookings/scheduled-bookings.js